import adicionalRouters from '@/modules/outros/adicional/router';
import entradaRouters from '@/modules/estoque/entrada/router';
import contagemEstoqueRouters from '@/modules/estoque/contagemEstoque/router';
import transferenciaRouters from '@/modules/estoque/transferencia/router';

export default [...adicionalRouters, ...entradaRouters, ...contagemEstoqueRouters, ...transferenciaRouters];
